import React from "react";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";

const TmsReportTollgateSummaryReport = () => {
  return <div>Summary Report</div>;
};

export default withRouter(TmsReportTollgateSummaryReport);
